/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - Images
 */
import { ViewIcon } from '../../../../images/icons/View/View'
import { RenewalIcon } from '../../../../images/icons/Renewal/Renewal'

/**
 * Each Quotes row from the RenewalsTable component
 *
 * @export
 * @class RenewalsRowQuotes
 * @extends {React.Component<any, any>}
 */
export default class RenewalsRowQuotes extends React.Component<any, any> {

    render() {
        return (
            <div>
                <div className="table__row row_shadow">
                    <div className="column" />
                    <div className="column no-margin">{this.props.quote.clientName}</div>
                    <div className="column">{this.props.quote.renewalDate}</div>
                    <div className="column">{this.props.quote.policyNumber}</div>
                    <div className="column">&pound;{this.props.quote.premium}</div>
                    <div className="column center">
                        <div
                            className=
                            {`${(this.props.manageAgency) ?
                                'disabled' :
                                ''}`}
                        >
                            <Link
                                to={`${(!this.props.manageAgency) ?
                                    '/clients/policies/view/' + this.props.quote.id :
                                    null}`}
                            >
                                <ViewIcon />
                            </Link>
                        </div>
                        <div
                            onClick={() => {
                                if (!this.props.quote.manual && !this.props.manageAgency) {
                                    this.props.showRenewPolicyPopUp(true, this.props.quote.id)
                                }
                            }
                            }
                            className={`${(this.props.quote.manual || this.props.manageAgency) ? 'disabled' : ''}`}
                        >
                            <RenewalIcon />
                        </div>
                    </div>
                </div>
                {(this.props.quote.mtas) ?
                    this.props.quote.mtas.map((item, i) => (
                        <div
                            className="policiesListRow__row--mtas"
                            key={i}
                        >
                            <div className="column--mtas" />
                            <div className="column--mtas">{item.title}</div>
                            <div className="column--mtas">Effective date: {item.effectiveDate}</div>
                            <div className="column--mtas">Expiry date: {item.expiryDate}</div>
                            <div className="column--mtas" />
                            <div className="column--mtas" />
                        </div>
                    ))
                    :
                    null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/components/RenewalsRowPolicies.tsx